import api from '../_api'
import { getCookie } from "../../../util/cookies";

const login = ({ commit, state, dispatch }, {code, oauthState, email}) => {
  return new Promise((resolve, reject) => {
    if (state.isAuth !== null) {
      resolve({
        success: state.isAuth,
        isJForce: state.isJForce,
        acceptedAgreement: state.acceptedTermsAndCondition,
        isInactive: state.isInactive,
        isPaymentMethodMandatory: state.isPaymentMethodMandatory,
        hasPaymentMethod: state.hasPaymentMethod,
        paymentMethodNeedConfirmation: state.paymentMethodNeedConfirmation,
        jforceId: state.id,
        jumiaId: state.jumiaId,
        updatedJforceAgreement: state.updated_jforce_agreement
      })
    } else {
      dispatch('app/getPeriods', { reverse: true }, { root: true })
      if (!code || !oauthState || oauthState !== getCookie('auth-state')) {
        window.dispatchEvent(new CustomEvent('cookie-not-found', {bubbles: true}))
        resolve({
          success: false
        })
        return
      }

      if (!email){
        email = getCookie("impersonate")
      }

      if (email) {
        commit('user/IS_IMPERSONATE', true)
      }

      const referralCode = getCookie('referralCode');
      api
        .login(code, email, referralCode)
        .then(response => {
          if (response.success) {
            commit('USER_UPDATED', response.data)
            commit('KYC_FIELDS', response.data.kyc)
            commit('app/APP_TOGGLE_FEATURES', response.data.toggleFeatures, {
              root: true
            })

            resolve({
              success: response.success,
              isJForce: response.data.isJForce,
              acceptedAgreement: response.data.acceptedTermsAndCondition,
              isInactive: response.data.isInactive,
              isPaymentMethodMandatory: response.data.isPaymentMethodMandatory,
              hasPaymentMethod: response.data.hasPaymentMethod,
              paymentMethodNeedConfirmation:
                response.data.paymentMethodNeedConfirmation,
              jforceId: response.data.id,
              jumiaId: response.data.jumiaId,
              updatedJforceAgreement: response.data.updated_jforce_agreement
            })
          } else {
            commit('USER_UPDATED', {
              isAuth: false,
              isJForce: false,
              isInactive: false,
              acceptedAgreement: false,
              isPaymentMethodMandatory: false,
              hasPaymentMethod: false,
              updatedJforceAgreement: false
            })
            resolve({
              success: false
            })
          }
        })
        .catch(error => {
          console.error(error)

          resolve({
            success: false
          })
        })
    }
  })
}

const acceptAgreement = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api
      .acceptAgreement(state.id)
      .then(response => {
        if (response.success) {
          commit('TERMS_AND_CONDITIONS_ACCEPTED')
        }

        resolve({
          success: response.success
        })
      })
      .catch(error => {
        console.error(error)

        reject(error)
      })
  })
}

const getLocations = ({ commit }) => {
  commit('LOCATION_LOADING')
  api
    .fetchLocations()
    .then(response => {
      if (response.success) {
        commit('LOCATION_UPDATED', response.data)
      } else {
        commit('LOCATION_ERROR')
      }
    })
    .catch(error => {
      console.error(error)
      commit('LOCATION_ERROR')
    })
}

const getCities = ({ commit, state }, id) => {
  commit('CITIES_LOADING')
  api
    .fetchCities(id)
    .then(response => {
      if (response.success) {
        commit('CITIES_UPDATED', response.data)
      } else {
        commit('CITIES_ERROR')
      }
    })
    .catch(error => {
      console.error(error)
      commit('LOCATION_ERROR')
    })
}

const getBanks = ({ commit }) => {
  commit('BANKS_LOADING')
  api
    .fetchBanks()
    .then(response => {
      if (response.success) {
        commit('BANKS_UPDATED', response.data)
      } else {
        commit('BANKS_ERROR')
      }
    })
    .catch(error => {
      console.error(error)
      commit('BANKS_ERROR')
    })
}

const getRecruitmentChannels = ({ commit }) => {
  commit('RECRUITMENT_CHANNELS_LOADING')
  api
    .fetchRecruitmentChannels()
    .then(response => {
      if (response.success) {
        commit('RECRUITMENT_CHANNELS_UPDATED', response.data)
      } else {
        commit('RECRUITMENT_CHANNELS_ERROR')
      }
    })
    .catch(error => {
      console.error(error)
      commit('RECRUITMENT_CHANNELS_ERROR')
    })
}

const getNetworks = ({ commit }) => {
  commit('NETWORKS_LOADING')
  api
    .fetchNetworks()
    .then(response => {
      if (response.success) {
        commit('NETWORKS_UPDATED', response.data)
      } else {
        commit('NETWORKS_ERROR')
      }
    })
    .catch(error => {
      console.error(error)
      commit('NETWORKS_ERROR')
    })
}

const getLanguages = ({ commit }) => {
  commit('LANGUAGES_LOADING')
  api
    .fetchLanguages()
    .then(response => {
      if (response.success) {
        commit('LANGUAGES_UPDATED', response.data)
      } else {
        commit('LANGUAGES_ERROR')
      }
    })
    .catch(error => {
      console.error(error)
      commit('LANGUAGES_ERROR')
    })
}

const getJforceTypes = ({ commit }) => {
  commit('JFORCETYPES_LOADING')
  api
    .fetchJforceTypes()
    .then(response => {
      if (response.success) {
        commit('JFORCETYPES_UPDATED', response.data)
      } else {
        commit('JFORCETYPES_ERROR')
      }
    })
    .catch(error => {
      console.error(error)
      commit('JFORCETYPES_ERROR')
    })
}
const getTimeslots = ({ commit }) => {
  commit('TIMESLOTS_LOADING')
  api
    .fetchSlots()
    .then(response => {
      if (response.success) {
        commit('TIMESLOTS_UPDATED', response.data)
      } else {
        commit('TIMESLOTS_ERROR')
      }
    })
    .catch(error => {
      console.error(error)
      commit('TIMESLOTS_ERROR')
    })
}

const createUser = ({ commit, state }, user) => {
  return new Promise((resolve, reject) => {
    api.createUser(user).then(response => {
      if (response.success) {
        commit('USER_UPDATED', response.data)
      } else {
        commit('USER_UPDATED_ERROR', response.errors)
      }

      resolve({ success: response.success })
    })
  })
}

const updateUser = ({ commit, state }, user) => {
  return new Promise((resolve, reject) => {
    api.updateUser(state.id, user).then(response => {
      if (response.success) {
        commit('USER_UPDATED', response.data)
      } else {
        commit('USER_UPDATED_ERROR', response.errors)
      }

      resolve({ success: response.success })
    })
  })
}

const cleanPhoneNumberErrors = ({ commit }) => {
  commit('USER_UPDATED_ERROR', {
    phoneNumberError: false
  })
}

const cleanSystemErrors = ({ commit }) => {
  commit('USER_UPDATED_ERROR', {
    systemError: false
  })
}

const cleanFirstNameErrors = ({ commit }) => {
  commit('USER_UPDATED_ERROR', {
    firstNameError: false
  })
}

const cleanLastNameErrors = ({ commit }) => {
  commit('USER_UPDATED_ERROR', {
    lastNameError: false
  })
}

const cleanEmailErrors = ({ commit }) => {
  commit('USER_UPDATED_ERROR', {
    emailError: false
  })
}

const getPaymentMethodById = ({ commit, state }, id) => {
  return new Promise((resolve, reject) => {
    commit('PAYMENT_METHOD_LOADING')

    if (state.paymentMethods && state.paymentMethods[id]) {
      commit('PAYMENT_METHOD_UPDATED', state.paymentMethods[id])
      resolve({
        success: true
      })
    } else {
      api
        .fetchPaymentMethods(state.id)
        .then(response => {
          if (response.success) {
            if (response.data[id]) {
              commit('PAYMENT_METHOD_UPDATED', response.data[id])
              resolve({
                success: true
              })
            } else {
              commit('PAYMENT_METHOD_ERROR')
              resolve({
                success: false
              })
            }
          } else {
            commit('PAYMENT_METHOD_ERROR')
            resolve({
              success: false
            })
          }
        })
        .catch(error => {
          console.error(error)
          commit('PAYMENT_METHOD_ERROR')
          resolve({
            success: false
          })
        })
    }
  })
}

const getAvailablePaymentMethods = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    if (state.availablePaymentMethods) {
      resolve({
        success: true
      })
    } else {
      commit('AVAILABLE_PAYMENT_METHODS_LOADING')
      api
        .fetchAvailablePaymentMethods(state.id)
        .then(response => {
          if (response.success) {
            commit('AVAILABLE_PAYMENT_METHODS_UPDATED', response.data)
            resolve({
              success: true
            })
          } else {
            commit('AVAILABLE_PAYMENT_METHODS_ERROR')
            resolve({
              success: false
            })
          }
        })
        .catch(error => {
          console.error(error)
          commit('AVAILABLE_PAYMENT_METHODS_ERROR')
          resolve({
            success: false
          })
        })
    }
  })
}

const getPaymentMethods = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    commit('PAYMENT_METHODS_LOADING')
    api
      .fetchPaymentMethods(state.id)
      .then(response => {
        if (response.success) {
          commit('PAYMENT_METHODS_UPDATED', response.data)
        } else {
          commit('PAYMENT_METHODS_ERROR')
        }

        resolve({
          success: response.success
        })
      })
      .catch(error => {
        console.error(error)
        commit('PAYMENT_METHODS_ERROR')

        reject(error)
      })
  })
}

const getImageLink = ({ commit }, file) => {
  return new Promise((resolve, reject) => {
    api
      .getImageUrl(file)
      .then(response => {
        if (response.success) {
          resolve({
            data: response,
            success: response.success
          })
        } else {
          resolve({
            success: false
          })
        }
      })
      .catch(error => {
        console.error(error)
        reject(error)
      })
  })
}
const addPaymentMethod = ({ commit, state }, paymentMethod) => {
  return new Promise((resolve, reject) => {
    api
      .addPaymentMethod(state.id, paymentMethod)
      .then(response => {
        if (response.success) {
          commit('PAYMENT_METHOD_ADDED', response.data)
        } else {
          commit('PAYMENT_METHOD_ADDED_ERROR', response.errors)
        }

        resolve({
          success: response.success
        })
      })
      .catch(error => {
        console.error(error)

        reject(error)
      })
  })
}

const updatePaymentMethod = ({ commit, state }, paymentMethod) => {
  return new Promise((resolve, reject) => {
    api
      .updatePaymentMethod(state.id, paymentMethod.id, paymentMethod)
      .then(response => {
        if (response.success) {
          commit('PAYMENT_METHOD_UPDATED', response.data)
        } else {
          commit('PAYMENT_METHOD_UPDATED_ERROR', response.errors)
        }

        resolve({
          success: response.success
        })
      })
      .catch(error => {
        console.error(error)
        // TODO: commit error
        reject(error)
      })
  })
}

export default {
  login,
  acceptAgreement,
  getLocations,
  getCities,
  getBanks,
  getRecruitmentChannels,
  getLanguages,
  getTimeslots,
  getJforceTypes,
  getNetworks,
  getAvailablePaymentMethods,
  getPaymentMethods,
  getPaymentMethodById,
  createUser,
  updateUser,
  getImageLink,

  addPaymentMethod,
  updatePaymentMethod,

  cleanPhoneNumberErrors,
  cleanSystemErrors,
  cleanFirstNameErrors,
  cleanLastNameErrors,
  cleanEmailErrors
}
